import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { IHelpPagePartner } from '@whitelabel/xcover-shared/helpers/types';
import contactHoverMsg from '@whitelabel/xcover-shared/helpers/messages/contactHoverMsg';
import HoverButton from '@whitelabel/component-library/src/components/HoverButton';
import { useZendeskChat } from '@whitelabel/xcover-shared/components/PartnerZendeskChat';
import ContactModal from '../ContactModal';

interface IContactHoverProps {
  insPartner?: IHelpPagePartner;
  bookingID?: string;
}

const ContactHover = ({ insPartner, bookingID }: IContactHoverProps) => {
  const { formatMessage } = useIntl();
  const [showModal, setShowModal] = useState(false);
  const { isZendeskChatOpen } = useZendeskChat();

  const toggleModal = () => {
    setShowModal((prev: boolean) => !prev);
  };

  useEffect(() => {
    if (isZendeskChatOpen) {
      // hide contact hover and close modal when showing Zendesk chat
      setShowModal(false);
    }
  }, [isZendeskChatOpen]);

  return (
    <>
      {!isZendeskChatOpen && (
        <HoverButton onClick={toggleModal} buttonHoverText={formatMessage(contactHoverMsg.contactButtonHoverText)} />
      )}
      {showModal && (
        <ContactModal
          toggleIsModalOpen={toggleModal}
          isOpen={showModal}
          insPartner={insPartner}
          bookingID={bookingID}
        />
      )}
    </>
  );
};

export default ContactHover;
